import {
    useMemo,
    type FC,
    useRef
} from "react";
import {
    type LayoutChangeEvent,
    Animated
} from "react-native";
import type IPresenceItemProps from "./type";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    getSlideStyle,
    usePresence
} from "../../../../helpers/motion";
import type {
    PresenceSize
} from "../../type";
import {
    getPresenceExitStyle
} from "../../util";

const PresenceItem: FC<IPresenceItemProps> = ({
    isInitialAnimated,
    customTheme,
    isPresent,
    children,
    onExited,
    style,
    axis,
    gap
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const sizeRef = useRef<PresenceSize>({
        height: 0,
        width: 0
    });

    const {
        isReduceMotionEnabled,
        progress
    } = usePresence({
        isNativeDriverEnabled: false,
        enterIntent: "listInsert",
        exitIntent: "listRemove",
        isVisible: isPresent,
        isInitialAnimated,
        customTheme,
        onExited
    });

    const motionStyle = useMemo(() => {
        if(isPresent) {
            return getSlideStyle({
                offset: spaces.spacingSm,
                isReduceMotionEnabled,
                progress
            });
        }

        return getPresenceExitStyle({
            isReduceMotionEnabled,
            size: sizeRef.current,
            progress,
            axis,
            gap
        });
    }, [
        isReduceMotionEnabled,
        spaces.spacingSm,
        isPresent,
        progress,
        axis,
        gap
    ]);

    const onLayout = (event: LayoutChangeEvent) => {
        if(!isPresent) {
            return;
        }

        sizeRef.current = {
            height: event.nativeEvent.layout.height,
            width: event.nativeEvent.layout.width
        };
    };

    return <Animated.View
        onLayout={onLayout}
        style={[
            style,
            motionStyle
        ]}
    >
        {children}
    </Animated.View>;
};
export default PresenceItem;
